export enum BookingError {
  AMEND_BOOKING_FAILURE = 'AMEND_BOOKING_FAILURE',
  BAD_USER_INPUT = 'BAD_USER_INPUT',
  CANCEL_BOOKING_FAILURE = 'CANCEL_BOOKING_FAILURE',
  CREATE_BOOKING_ERROR = 'CREATE_BOOKING_ERROR',
  CREATE_BOOKING_FAILURE = 'CREATE_BOOKING_FAILURE',
  CREATE_BOOKING_STATUS_FAILURE = 'CREATE_BOOKING_STATUS_FAILURE',
  EMAIL_VALIDATION = 'EMAIL_VALIDATION',
  ERR_BOOKING_ALREADY_CANCELLED = 'ERR_BOOKING_ALREADY_CANCELLED',
  ERR_BOOKING_AUTHORIZATION = 'ERR_BOOKING_AUTHORIZATION',
  ERR_BOOKING_NOT_FOUND = 'ERR_BOOKING_NOT_FOUND',
  ERR_BOOKING_NOT_OWNED = 'ERR_BOOKING_NOT_OWNED',
  ERR_CANCELATION_NOT_ALLOWED = 'ERR_CANCELATION_NOT_ALLOWED',
  ERR_CANCELLATION_FAILED = 'ERR_CANCELLATION_FAILED',
  ERR_CANCELLATION_FAILED_WITH_SUCCESS = 'ERR_CANCELLATION_FAILED_WITH_SUCCESS',
  ERR_MEMBERSHIP_ALREADY_CONNECTED = 'ERR_MEMBERSHIP_ALREADY_CONNECTED',
  ERR_SOMETHING_WENT_WRONG = 'ERR_SOMETHING_WENT_WRONG',
  ERR_TOKEN_INVALID_OR_EXPIRED = 'ERR_TOKEN_INVALID_OR_EXPIRED',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  INVALID_CONSUMER = 'INVALID_CONSUMER',
  INVALID_PREBOOK_PERIOD = 'INVALID_PREBOOK_PERIOD',
  JWT_DECODE_ERROR = 'JWT_DECODE_ERROR',
  JWT_VALIDATION_ERROR = 'JWT_VALIDATION_ERROR',
  LOGIN_FAILED = 'LOGIN_FAILED',
  LOUNGE_NOT_FOUND = 'LOUNGE_NOT_FOUND',
  MISSING_PRODUCT_ID = 'MISSING_PRODUCT_ID',
  MISSING_REQUIRED_PARAMS_ERROR = 'MISSING_REQUIRED_PARAMS_ERROR',
  MISSING_WINDOW_OBJECT = 'MISSING_WINDOW_OBJECT',
  MULTIPLE_LOGOUTS_INITIATED = 'MULTIPLE_LOGOUTS_INITIATED',
  NEW_USER_SIGNUP_FAILURE = 'NEW_USER_SIGNUP_FAILURE',
  NO_PRODUCTS_ERROR = 'NO_PRODUCTS_ERROR',
  UNABLE_TO_GET_PAYMENT_LINK = 'UNABLE_TO_GET_PAYMENT_LINK',
  UNABLE_TO_RETRIEVE_PARAMS = 'UNABLE_TO_RETRIEVE_PARAMS',
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
  UNNABLE_TO_COMPLETE_PAYMENT = 'UNNABLE_TO_COMPLETE_PAYMENT',
}

export enum BookingWarn {
  BOOKING_POLL_SOFT_ALERT = 'BOOKING_POLL_SOFT_ALERT',
  MULTIPLE_LOGIN_ATTEMPTS = 'MULTIPLE_LOGIN_ATTEMPTS',
  CREATE_PDF_FAILED = 'CREATE_PDF_FAILED',
  ENROLL_ENTITLEMENTS_RETURNS_FALSE = 'ENROLL_ENTITLEMENTS_RETURNS_FALSE',
  EXPIRED_USER_INPUT_CODE_ERROR = 'EXPIRED_USER_INPUT_CODE_ERROR',
  FAILED_TO_FETCH_ENTITLEMENTS = 'FAILED_TO_FETCH_ENTITLEMENTS',
  INCORRECT_USER_INPUT_CODE_ERROR = 'INCORRECT_USER_INPUT_CODE_ERROR',
  INVALID_EMAIL_PROVIDED = 'INVALID_EMAIL_PROVIDED',
  JSON_PARSE_FAILED = 'JSON_PARSE_FAILED',
  JWT_VALIDATION_FAILED = 'JWT_VALIDATION_FAILED',
  LOCAL_STORAGE_GET_FAILED = 'LOCAL_STORAGE_GET_FAILED',
  LOCAL_STORAGE_SET_FAILED = 'LOCAL_STORAGE_SET_FAILED',
  MEMBERSHIP_ALREADY_CONNECTED = 'MEMBERSHIP_ALREADY_CONNECTED',
  MISSED_TRANSLATION_KEYS = 'MISSED_TRANSLATION_KEYS',
  NO_CODE_PROVIDED_FOR_OTP = 'NO_CODE_PROVIDED_FOR_OTP',
  NO_MOBILE_ENV = 'NO_MOBILE_ENV',
  PDF_GUIDE_URL_INVALID = 'PDF_GUIDE_URL_INVALID',
  RESTART_FLOW_ERROR = 'RESTART_FLOW_ERROR',
  SESSION_STORAGE_GET_FAILED = 'SESSION_STORAGE_GET_FAILED',
  SESSION_STORAGE_REMOVE_FAILED = 'SESSION_STORAGE_REMOVE_FAILED',
  SESSION_STORAGE_SET_FAILED = 'SESSION_STORAGE_SET_FAILED',
  SIGN_OUT_FAILED = 'SIGN_OUT_FAILED',
  SLOT_AVAILABILITY_SOFT_BLOCK = 'SLOT_AVAILABILITY_SOFT_BLOCK',
}

export enum BookingInfo {
  AMEND_BOOKING_ATTEMPT = 'AMEND_BOOKING_ATTEMPT',
  AMEND_BOOKING_SUCCESS = 'AMEND_BOOKING_SUCCESS',
  ATTEMPTING_TO_LINK_ACCOUNT = 'ATTEMPTING_TO_LINK_ACCOUNT',
  CANCEL_BOOKING_ATTEMPT = 'CANCEL_BOOKING_ATTEMPT',
  CANCEL_BOOKING_SUCCESS = 'CANCEL_BOOKING_SUCCESS',
  COMPLETE_USER_FLOW = 'COMPLETE_USER_FLOW',
  CONSUMER_INFO = 'CONSUMER_INFO',
  CREATE_BOOKING_ATTEMPT = 'CREATE_BOOKING_ATTEMPT',
  CREATE_BOOKING_SUCCESS = 'CREATE_BOOKING_SUCCESS',
  EMAIL_TOKEN_PROVIDED = 'EMAIL_TOKEN_PROVIDED',
  ENROLL_DEAL_RESULT = 'ENROLL_DEAL_RESULT',
  ENROLLED_ACCOUNT_NOT_FOUND = 'ENROLLED_ACCOUNT_NOT_FOUND',
  ENROLLED_MEMBERSHIP_NOT_FOUND = 'ENROLLED_MEMBERSHIP_NOT_FOUND',
  ENTITLEMENTS_POLL_RESULT = 'ENTITLEMENTS_POLL_RESULT',
  FAILED_TO_LINK_NEW_ACCOUNT = 'FAILED_TO_LINK_NEW_ACCOUNT',
  FINAL_BOOKING_STATE = 'FINAL_BOOKING_STATE',
  INITIATE_USER_FLOW = 'INITIATE_USER_FLOW',
  INVALID_PAYLOAD_RECEIVED = 'INVALID_PAYLOAD_RECEIVED',
  LINKED_ACCOUNT_FOUND = 'LINKED_ACCOUNT_FOUND',
  LINKED_ACOUNT_UPDATE_SOURCE_CODE = 'LINKED_ACOUNT_UPDATE_SOURCE_CODE',
  LINKED_NEW_ACCOUNT_SUCCESSFULLY = 'LINKED_NEW_ACCOUNT_SUCCESSFULLY',
  LOCATION_PRODUCT_RESPONSE = 'LOCATION_PRODUCT_RESPONSE',
  LOUNGE_REQUEST = 'LOUNGE_REQUEST',
  MATCHED_EXISTING_MEMBERSHIP = 'MATCHED_EXISTING_MEMBERSHIP',
  MEMBERSHIP_FOUND_WITHOUT_SOURCE_CODE = 'MEMBERSHIP_FOUND_WITHOUT_SOURCE_CODE',
  MEMBERSHIP_MATCH_RESULT = 'MEMBERSHIP_MATCH_RESULT',
  NEW_USER_SIGNUP = 'NEW_USER_SIGNUP',
  OUTLET_PRODUCT_RESPONSE = 'OUTLET_PRODUCT_RESPONSE',
  POLLING_STARTED = 'POLLING_STARTED',
  PRODUCT_RESPONSE = 'PRODUCT_RESPONSE',
  REDIRECT_NEW_USER_SIGNUP_TO_SIGNUP = 'REDIRECT_NEW_USER_SIGNUP_TO_SIGNUP',
  REDIRECT_TO_LOGIN = 'REDIRECT_TO_LOGIN',
  UPDATE_CONSUMER = 'UPDATE_CONSUMER',
  USE_FT_FALLBACK = 'USE_FT_FALLBACK',
  USER_VALIDATION_LINKED_ACCOUNT_FOUND = 'USER_VALIDATION_LINKED_ACCOUNT_FOUND',
  USER_VALIDATION_MEMBERSHIP_FOUND = 'USER_VALIDATION_MEMBERSHIP_FOUND',
  VALID_PAYLOAD_RECEIVED = 'VALID_PAYLOAD_RECEIVED',
  VALUATION_PRODUCT_RESPONSE = 'VALUATION_PRODUCT_RESPONSE',
}

export enum ANALYTICS_TAGS {
  ON_AMEND_BOOKING_PG_ENTER = 'On_PG_Amnd_Bk',
  ON_BOOKING_FINALIZED = 'On_Bk_Finalized',
  ON_CANCEL_BOOKING_PG_ENTER = 'On_PG_Cncl_Bk',
  ON_CANCEL_CONFIRM_CLICK = 'CK_BTN_Cncl_Bk_Cnfm',
  ON_CANCEL_MODAL_OPEN = 'On_Mdl_Cncl_Bk',
  ON_CANCELLED_BOOKING_PG_ENTER = 'On_PG_Cncl_Bk_Cfnd',
  ON_CHANGE_DATE = 'CG_Flight_Date_Chk_Avl',
  ON_CHANGE_DATE_EDIT = 'CG_Flight_Date_Chk_Avl_Amnd',
  ON_CHANGE_DATE_ERROR = 'ERR_Flight_Date_Chk_Avl',
  ON_CHANGE_DATE_ERROR_EDIT = 'ERR_Flight_Date_Chk_Avl_Amnd',
  ON_CHANGE_EMAIL_ADDRESS = 'CHG_Email_Address',
  ON_CHANGE_FLIGHT_NUMBER = 'CG_Flight_Number_Chk_Avl',
  ON_CHANGE_FLIGHT_NUMBER_EDIT = 'CG_Flight_Number_Chk_Avl_Amnd',
  ON_CHANGE_FLIGHT_NUMBER_ERROR = 'ERR_Flight_Number_Chk_Avl',
  ON_CHANGE_FLIGHT_NUMBER_ERROR_EDIT = 'ERR_Flight_Number_Chk_Avl_Amnd',
  ON_CHECK_CODE_CHANGE = 'CG_Email_Code',
  ON_CHECK_CODE_ENTER = 'On_PG_Email_Code',
  ON_CHECK_CODE_VERIFY = 'Ck_BTN_Verify_Email_Code',
  ON_CHECK_FT_LOCATIONS_AUTO_REDIRECT = 'On_FT_Loc_Auto_Redirect',
  ON_CHECK_FT_LOCATIONS_PROCEED = 'CK_BTN_FT_Loc_Proceed',
  ON_CHECK_FT_LOCATIONS_SELECT = 'CK_Card_FT_Loc_Select',
  ON_CONFIRM_AMEND_PG = 'On_PG_Sv_Chng_Amnd',
  ON_CONFIRM_AMEND_SAVE = 'CK_BTN_Sv_Chng_Amnd',
  ON_CONFIRM_BOOKING_PG_ENTER = 'On_PG_Cfm_Bk',
  ON_CONFIRMED_BTN_DECLINE = 'On_PG_Amnd_Dclnd',
  ON_CONFIRMED_BTN_DOWNLOAD_AMEND = 'CK_BTN__Amnd_Cfnd',
  ON_CONTINUE_BUTTON_AVI = 'CK_BTN_Chk_Avl',
  ON_CONTINUE_BUTTON_AVI_EDIT = 'CK_BTN_Chk_Avl_Amnd',
  ON_CONTINUE_CLICK = 'CK_BTN_Continue',
  ON_FASTTRACK_CONSENT_AGREE = 'CK_BTN_Fasttrack_Consent_Agree',
  ON_FASTTRACK_CONSENT_TERMS_CLICK = 'CK_Link_Fasttrack_Consent_Terms',
  ON_FT_ENTITLEMENT_OK_CLICK = 'CK_BTN_FT_Entitlement_OK',
  ON_FT_ENTITLEMENT_PG_ENTER = 'On_PG_FT_Entitlement',
  ON_FASTTRACK_PDF_GUIDE_CLICK = 'CK_Link_Fasttrack_PDF_Guide',
  ON_HIT_BACK_BUTTON = 'CK_BTN_Back_',
  ON_INDICATOR_LOADED_ON = 'On_Bsns_Indicator_ON',
  ON_INDICATOR_REACHED_WITH_SCROLL = 'On_Bsns_Indicator_Scrolled',
  ON_INDICATOR_SELECTED_LEVEL = 'CK_Pick_Slot_Bsns_Indicator',
  ON_LOGIN_SUCCESS = 'On_Login_Success',
  ON_PAGE_CONFIRMED_BTN_DOWNLOAD = 'CK_BTN__Bk_Cfnd',
  ON_PAGE_ENTER_CHECKAVAILABILITY = 'On_PG_Chk_Avl',
  ON_PAGE_ENTER_CHECKAVAILABILITY_EDIT = 'On_PG_Chk_Avl_Amnd',
  ON_PAGE_ENTER_CONFIRMED = 'On_PG_Bk_Cfnd',
  ON_PAGE_ENTER_CONFIRMED_AMEND = 'On_PG_Amnd_Cfnd',
  ON_PAGE_ENTER_EMAIL = 'On_PG_Enter_Email',
  ON_PAYMENT_CONTINUE = 'CK_BTN_Confirm_G_T_Pmt',
  ON_PAYMENT_ENTER = 'On_PG_G_T_Pmt',
  ON_PAYMENT_PROCESSED = 'On_PG_Processing_Pmt',
  ON_REFUND_AMENDMENT_ENTER = 'On_PG_Amnd_Cfnd_Rfnd',
  ON_REFUND_FAILED_AMEND = 'CK_BTN__Amnd_Cfnd_Rfnd_Err',
  ON_SIGNUP_FAILURE = 'On_Signup_Failure',
  ON_SIGNUP_PAGE_CONCENT = 'Tick_Consent_Upd_Dtl',
  ON_SIGNUP_PAGE_CONFIRM = 'CK_BTN_Confirm_Upd_Dtl',
  ON_SIGNUP_PAGE_ENTER = 'On_PG_Upd_Dtl',
  ON_SIGNUP_PAGE_FIRSTNAME_UPDATE = 'CG_First_Name_Upd_Dtl',
  ON_SIGNUP_PAGE_LASTNAME_UPDATE = 'CG_Last_Name_Upd_Dtl',
  ON_SIGNUP_SUCCESS = 'On_Signup_Success',
  ON_SLOT_AMEND_CONFIRMED = 'CK_BTN_Confirm_Pick_Slot_Amnd',
  ON_SLOT_AMEND_ENTER = 'On_PG_Pick_Slot_Amnd',
  ON_SLOT_CHANGE = 'CK_Time_Slot_Pick_Slot',
  ON_SLOT_CHANGED_AMEND = 'CK_Time_Slot_Pick_Slot_Amnd',
  ON_SLOT_CONTINUE = 'CK_BTN_Confirm_Pick_Slot',
  ON_SLOT_LIST_RENDERED = 'On_Slot_List_Rendered',
  ON_SLOT_MISSED = 'On_PG_Slot_Mis',
  ON_SLOT_PG_ENTER = 'On_PG_Pick_Slot',
  ON_SLOT_SELECT_ANOTHER = 'CK_BTN_Sel_Slot_Mis',
  ON_TOOLTIP_SELECTED = 'CK_Question_Mark_Bsns_In',
}

export const DATADOG_ERROR_LOGS = {
  [BookingError.AMEND_BOOKING_FAILURE]: 'Amend booking failed',
  [BookingError.BAD_USER_INPUT]: BookingError.BAD_USER_INPUT,
  [BookingError.CANCEL_BOOKING_FAILURE]: 'Cancel booking failed',
  [BookingError.CREATE_BOOKING_ERROR]:
    'There was an error during create booking',
  [BookingError.CREATE_BOOKING_FAILURE]: 'Create booking failed',
  [BookingError.CREATE_BOOKING_STATUS_FAILURE]:
    'Create booking returned a failed status',
  [BookingError.EMAIL_VALIDATION]:
    'An error occured while validating email address',
  [BookingError.ERR_BOOKING_ALREADY_CANCELLED]:
    BookingError.ERR_BOOKING_ALREADY_CANCELLED,
  [BookingError.ERR_BOOKING_AUTHORIZATION]:
    BookingError.ERR_BOOKING_AUTHORIZATION,
  [BookingError.ERR_BOOKING_NOT_FOUND]: BookingError.ERR_BOOKING_NOT_FOUND,
  [BookingError.ERR_BOOKING_NOT_OWNED]: BookingError.ERR_BOOKING_NOT_OWNED,
  [BookingError.ERR_CANCELATION_NOT_ALLOWED]:
    BookingError.ERR_CANCELATION_NOT_ALLOWED,
  [BookingError.ERR_CANCELLATION_FAILED]: BookingError.ERR_CANCELLATION_FAILED,
  [BookingError.ERR_CANCELLATION_FAILED_WITH_SUCCESS]:
    BookingError.ERR_CANCELLATION_FAILED_WITH_SUCCESS,
  [BookingError.ERR_MEMBERSHIP_ALREADY_CONNECTED]:
    BookingError.ERR_MEMBERSHIP_ALREADY_CONNECTED,
  [BookingError.ERR_SOMETHING_WENT_WRONG]:
    BookingError.ERR_SOMETHING_WENT_WRONG,
  [BookingError.ERR_TOKEN_INVALID_OR_EXPIRED]:
    BookingError.ERR_TOKEN_INVALID_OR_EXPIRED,
  [BookingError.INTERNAL_SERVER_ERROR]: BookingError.INTERNAL_SERVER_ERROR,
  [BookingError.INVALID_CONSUMER]: BookingError.INVALID_CONSUMER,
  [BookingError.INVALID_PREBOOK_PERIOD]: BookingError.INVALID_PREBOOK_PERIOD,
  [BookingError.JWT_DECODE_ERROR]: BookingError.JWT_DECODE_ERROR,
  [BookingError.JWT_VALIDATION_ERROR]: BookingError.JWT_VALIDATION_ERROR,
  [BookingError.LOGIN_FAILED]: BookingError.LOGIN_FAILED,
  [BookingError.LOUNGE_NOT_FOUND]: BookingError.LOUNGE_NOT_FOUND,
  [BookingError.MISSING_PRODUCT_ID]: BookingError.MISSING_PRODUCT_ID,
  [BookingError.MISSING_REQUIRED_PARAMS_ERROR]: 'Missing required params',
  [BookingError.MISSING_WINDOW_OBJECT]: BookingError.MISSING_WINDOW_OBJECT,
  [BookingError.MULTIPLE_LOGOUTS_INITIATED]:
    BookingError.MULTIPLE_LOGOUTS_INITIATED,
  [BookingError.NEW_USER_SIGNUP_FAILURE]: 'New user signup failed',
  [BookingError.NO_PRODUCTS_ERROR]: 'No products found',
  [BookingError.UNABLE_TO_GET_PAYMENT_LINK]:
    BookingError.UNABLE_TO_GET_PAYMENT_LINK,
  [BookingError.UNABLE_TO_RETRIEVE_PARAMS]:
    'Unable to retrieve params from both query and storage',
  [BookingError.UNEXPECTED_ERROR]: BookingError.UNEXPECTED_ERROR,
  [BookingError.UNNABLE_TO_COMPLETE_PAYMENT]:
    BookingError.UNNABLE_TO_COMPLETE_PAYMENT,
};

export const DATADOG_WARN_LOGS = {
  [BookingWarn.BOOKING_POLL_SOFT_ALERT]:
    'Post-payment polling exceeded 10-attempt soft threshold without terminal state',
  [BookingWarn.CREATE_PDF_FAILED]: BookingWarn.CREATE_PDF_FAILED,
  [BookingWarn.ENROLL_ENTITLEMENTS_RETURNS_FALSE]:
    BookingWarn.ENROLL_ENTITLEMENTS_RETURNS_FALSE,
  [BookingWarn.EXPIRED_USER_INPUT_CODE_ERROR]:
    BookingWarn.EXPIRED_USER_INPUT_CODE_ERROR,
  [BookingWarn.FAILED_TO_FETCH_ENTITLEMENTS]:
    BookingWarn.FAILED_TO_FETCH_ENTITLEMENTS,
  [BookingWarn.INCORRECT_USER_INPUT_CODE_ERROR]:
    BookingWarn.INCORRECT_USER_INPUT_CODE_ERROR,
  [BookingWarn.INVALID_EMAIL_PROVIDED]: BookingWarn.INVALID_EMAIL_PROVIDED,
  [BookingWarn.JSON_PARSE_FAILED]: BookingWarn.JSON_PARSE_FAILED,
  [BookingWarn.JWT_VALIDATION_FAILED]: BookingWarn.JWT_VALIDATION_FAILED,
  [BookingWarn.LOCAL_STORAGE_GET_FAILED]: BookingWarn.LOCAL_STORAGE_GET_FAILED,
  [BookingWarn.LOCAL_STORAGE_SET_FAILED]: BookingWarn.LOCAL_STORAGE_SET_FAILED,
  [BookingWarn.MULTIPLE_LOGIN_ATTEMPTS]: BookingWarn.MULTIPLE_LOGIN_ATTEMPTS,
  [BookingWarn.MEMBERSHIP_ALREADY_CONNECTED]:
    BookingWarn.MEMBERSHIP_ALREADY_CONNECTED,
  [BookingWarn.MISSED_TRANSLATION_KEYS]:
    'There are missing keys in the translation object',
  [BookingWarn.NO_CODE_PROVIDED_FOR_OTP]: BookingWarn.NO_CODE_PROVIDED_FOR_OTP,
  [BookingWarn.NO_MOBILE_ENV]: 'Unable to detect mobile environment',
  [BookingWarn.PDF_GUIDE_URL_INVALID]:
    'Invalid PDF guide base URL configuration',
  [BookingWarn.RESTART_FLOW_ERROR]: BookingWarn.RESTART_FLOW_ERROR,
  [BookingWarn.SESSION_STORAGE_GET_FAILED]:
    'Failed to GET item from session storage',
  [BookingWarn.SESSION_STORAGE_REMOVE_FAILED]:
    'Failed to REMOVE item from session storage',
  [BookingWarn.SESSION_STORAGE_SET_FAILED]:
    'Failed to SET item to session storage',
  [BookingWarn.SIGN_OUT_FAILED]:
    'SuperTokens signOut request failed during session close',
  [BookingWarn.SLOT_AVAILABILITY_SOFT_BLOCK]:
    'User encountered a known pre-submit blocker in slot availability',
};

export const DATADOG_INFO_LOGS = {
  [BookingInfo.AMEND_BOOKING_ATTEMPT]: 'Amend booking attempt initiated',
  [BookingInfo.AMEND_BOOKING_SUCCESS]: 'Amend booking succeeded',
  [BookingInfo.ATTEMPTING_TO_LINK_ACCOUNT]:
    BookingInfo.ATTEMPTING_TO_LINK_ACCOUNT,
  [BookingInfo.CANCEL_BOOKING_ATTEMPT]: 'Cancel booking attempt initiated',
  [BookingInfo.CANCEL_BOOKING_SUCCESS]: 'Cancel booking succeeded',
  [BookingInfo.COMPLETE_USER_FLOW]: BookingInfo.COMPLETE_USER_FLOW,
  [BookingInfo.CONSUMER_INFO]: BookingInfo.CONSUMER_INFO,
  [BookingInfo.CREATE_BOOKING_ATTEMPT]: 'Create booking attempt initiated',
  [BookingInfo.CREATE_BOOKING_SUCCESS]: 'Create booking succeeded',
  [BookingInfo.EMAIL_TOKEN_PROVIDED]: BookingInfo.EMAIL_TOKEN_PROVIDED,
  [BookingInfo.ENROLL_DEAL_RESULT]: BookingInfo.ENROLL_DEAL_RESULT,
  [BookingInfo.ENROLLED_ACCOUNT_NOT_FOUND]:
    BookingInfo.ENROLLED_ACCOUNT_NOT_FOUND,
  [BookingInfo.ENROLLED_MEMBERSHIP_NOT_FOUND]:
    BookingInfo.ENROLLED_MEMBERSHIP_NOT_FOUND,
  [BookingInfo.ENTITLEMENTS_POLL_RESULT]: BookingInfo.ENTITLEMENTS_POLL_RESULT,
  [BookingInfo.FAILED_TO_LINK_NEW_ACCOUNT]:
    BookingInfo.FAILED_TO_LINK_NEW_ACCOUNT,
  [BookingInfo.FINAL_BOOKING_STATE]:
    'Post-payment booking polling reached a terminal state',
  [BookingInfo.INITIATE_USER_FLOW]: BookingInfo.INITIATE_USER_FLOW,
  [BookingInfo.INVALID_PAYLOAD_RECEIVED]: BookingInfo.INVALID_PAYLOAD_RECEIVED,
  [BookingInfo.LINKED_ACCOUNT_FOUND]: BookingInfo.LINKED_ACCOUNT_FOUND,
  [BookingInfo.LINKED_ACOUNT_UPDATE_SOURCE_CODE]:
    BookingInfo.LINKED_ACOUNT_UPDATE_SOURCE_CODE,
  [BookingInfo.LINKED_NEW_ACCOUNT_SUCCESSFULLY]:
    BookingInfo.LINKED_NEW_ACCOUNT_SUCCESSFULLY,
  [BookingInfo.LOCATION_PRODUCT_RESPONSE]:
    BookingInfo.LOCATION_PRODUCT_RESPONSE,
  [BookingInfo.LOUNGE_REQUEST]: BookingInfo.LOUNGE_REQUEST,
  [BookingInfo.MATCHED_EXISTING_MEMBERSHIP]:
    BookingInfo.MATCHED_EXISTING_MEMBERSHIP,
  [BookingInfo.MEMBERSHIP_FOUND_WITHOUT_SOURCE_CODE]:
    BookingInfo.MEMBERSHIP_FOUND_WITHOUT_SOURCE_CODE,
  [BookingInfo.MEMBERSHIP_MATCH_RESULT]: BookingInfo.MEMBERSHIP_MATCH_RESULT,
  [BookingInfo.NEW_USER_SIGNUP]: BookingInfo.NEW_USER_SIGNUP,
  [BookingInfo.OUTLET_PRODUCT_RESPONSE]: BookingInfo.OUTLET_PRODUCT_RESPONSE,
  [BookingInfo.POLLING_STARTED]:
    'Post-payment booking confirmation polling started',
  [BookingInfo.PRODUCT_RESPONSE]: BookingInfo.PRODUCT_RESPONSE,
  [BookingInfo.REDIRECT_NEW_USER_SIGNUP_TO_SIGNUP]:
    BookingInfo.REDIRECT_NEW_USER_SIGNUP_TO_SIGNUP,
  [BookingInfo.REDIRECT_TO_LOGIN]: BookingInfo.REDIRECT_TO_LOGIN,
  [BookingInfo.UPDATE_CONSUMER]: BookingInfo.UPDATE_CONSUMER,
  [BookingInfo.USE_FT_FALLBACK]: BookingInfo.USE_FT_FALLBACK,
  [BookingInfo.USER_VALIDATION_LINKED_ACCOUNT_FOUND]:
    BookingInfo.USER_VALIDATION_LINKED_ACCOUNT_FOUND,
  [BookingInfo.USER_VALIDATION_MEMBERSHIP_FOUND]:
    BookingInfo.USER_VALIDATION_MEMBERSHIP_FOUND,
  [BookingInfo.VALID_PAYLOAD_RECEIVED]: BookingInfo.VALID_PAYLOAD_RECEIVED,
  [BookingInfo.VALUATION_PRODUCT_RESPONSE]:
    BookingInfo.VALUATION_PRODUCT_RESPONSE,
};

export enum PAGENAMES {
  BOOKING_AMEND = 'Chk_Avl_Amnd',
  BOOKING_CANCEL = 'Cncl_Bk',
  BOOKING_CANCELLED = 'Cncl_Bk_Cfnd',
  BOOKING_CONFIRMED = 'BookingConfirmed',
  CHECK_FT_LOCATIONS = 'Chk_FT_Locations',
  CONFIRM_AMEND = 'Sv_Chng_Amnd',
  CONFIRM_CREATE = 'G_T_Pmt',
  EMAIL_CODE = 'Email_Code',
  ENTER_EMAIL = 'Enter_Email',
  FAILURE_AMEND_REFUND = 'Refund_fail',
  FASTTRACK_CONSENT = 'Fasttrack_Consent',
  SHOW_FT_ENTITLEMENT = 'Show_FT_Entitlement',
  FAULURE_BOOKING = 'Slot_Mis',
  INDEX = 'Chk_Avl',
  PICK_SLOT = 'Pick_Slot',
  SIGNUP = 'Upd_Dtl',
  SLOTAMEND = 'Slot_Amnd',
}
